import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'tpl-form-note',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form-note.component.html',
  styleUrls: ['./form-note.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormNoteComponent {}
